import { render, staticRenderFns } from "./AlarmSettings.vue?vue&type=template&id=bbe2de1e&scoped=true&"
import script from "./AlarmSettings.vue?vue&type=script&lang=js&"
export * from "./AlarmSettings.vue?vue&type=script&lang=js&"
import style0 from "./AlarmSettings.vue?vue&type=style&index=0&id=bbe2de1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe2de1e",
  null
  
)

export default component.exports